export function isNullOrUndefined<T>(
  obj: T | null | undefined
): obj is null | undefined {
  return typeof obj === "undefined" || obj === null;
}

/** localStorage key used to broadcast a logout event across tabs. */
export const LOGOUT_BROADCAST_KEY = "logout_broadcast";
